export default __webpack_public_path__ + "static/media/gallery_06.953542a1.jpg";